"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const CreateProgramScreen = () => (react_1.default.createElement("div", { className: styles_scss_1.default.manageProgramsCreate },
    react_1.default.createElement(components_1.Meta, { title: constants_1.default.managePrograms.helmetTitle, removeViewport: true }),
    react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.paperContainer },
        react_1.default.createElement(components_1.Link, { to: constants_1.Routes.ManagePrograms },
            react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.goBackButton, variant: "transparent", title: constants_1.default.manageAccounts.create.backToPrograms, ariaLabel: constants_1.default.manageAccounts.create.backToPrograms, imgUrls: { default: constants_1.Images.arrowLeftGreen, selected: constants_1.Images.arrowLeftGreen } })),
        react_1.default.createElement(forms_1.ProgramCreateForm, null))));
exports.default = CreateProgramScreen;
